import React from "react";
import styled from "styled-components";

const Root = styled.div`
  margin-bottom: 1.5rem;
`;

interface FormFieldProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export function FormField({ children, ...props }: FormFieldProps) {
  return <Root {...props}>{children}</Root>;
}
